module.exports = __webpack_public_path__ + "static/img/bihai.10bb844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bihai.png
// module id = Tsy7
// module chunks = 1